/* Marinelie — Warenkorb: die zwei Wege hinein, die Dawn nicht kennt.

   Beide legen eine echte Position an (/cart/add.js) und lassen Dawns
   Schubfach neu zeichnen — kein Fremdsystem, kein Sammelfeld.

   Die Zuhoerer haengen am Dokument, nicht an den Knoepfen: das Schubfach
   wird bei jeder Aenderung neu gerendert, an einem Knopf haftende
   Zuhoerer waeren danach weg. */
(function () {
  if (window.mlKorbBereit) return;
  window.mlKorbBereit = true;

  function korb() {
    return document.querySelector('cart-drawer');
  }

  function neuZeichnen(stand) {
    var k = korb();
    if (k && typeof k.renderContents === 'function') {
      if (stand.item_count !== 0) k.classList.remove('is-empty');
      k.renderContents(stand);
      return true;
    }
    return false;
  }

  function hinein(knopf, id, eigenschaften) {
    knopf.disabled = true;
    var pfad = (window.routes && window.routes.cart_add_url) || '/cart/add';

    var koerper = { id: id, quantity: 1 };
    if (eigenschaften) koerper.properties = eigenschaften;

    return fetch(pfad + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [koerper],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      }),
    })
      .then(function (antwort) {
        if (!antwort.ok) throw new Error('add fehlgeschlagen');
        return antwort.json();
      })
      .then(function (stand) {
        if (!neuZeichnen(stand)) window.location.reload();
      })
      .catch(function () {
        knopf.disabled = false;
      });
  }

  /* Nimmt die bisher gewaehlte Probe heraus. Ueber den Zeilenschluessel,
     nicht ueber die Varianten-ID: die Position traegt Eigenschaften, und
     nur der Schluessel trifft genau sie. Liegt keine da, passiert nichts. */
  function heraus(schluessel) {
    if (!schluessel) return Promise.resolve(null);
    var pfad = (window.routes && window.routes.cart_change_url) || '/cart/change';
    return fetch(pfad + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: schluessel, quantity: 0 }),
    })
      .then(function (antwort) {
        return antwort.ok ? antwort.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  /* Kostenlose Tester liegen hoechstens einmal je Variante im Korb (Otton,
     11.10.2026: "aktuell kann man dadurch 5 stueck holen"). Die fehlende
     Mengenanzeige allein haelt das nicht: auf der Produktseite legt jeder
     Klick einen dazu. Darum setzt der Korb solche Zeilen nach jeder
     Aenderung selbst auf 1 zurueck. Erkannt am Typ TESTER und am Preis
     vor Rabatten — ein bezahlter Tester mit 100-%-Code bleibt unberuehrt. */
  function gratisDeckeln() {
    var pfad = (window.routes && window.routes.cart_change_url) || '/cart/change';
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (antwort) {
        return antwort.ok ? antwort.json() : null;
      })
      .then(function (stand) {
        if (!stand) return;
        var zuviel = stand.items.filter(function (i) {
          return i.product_type === 'TESTER' && i.original_price === 0 && i.quantity > 1;
        });
        if (!zuviel.length) return;
        /* Nacheinander: zwei gleichzeitige Aenderungen am Korb koennen
           sich gegenseitig ueberschreiben. */
        return zuviel
          .reduce(function (kette, i) {
            return kette.then(function () {
              return fetch(pfad + '.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({
                  id: i.key,
                  quantity: 1,
                  sections: ['cart-drawer', 'cart-icon-bubble'],
                  sections_url: window.location.pathname,
                }),
              }).then(function (antwort) {
                return antwort.ok ? antwort.json() : null;
              });
            });
          }, Promise.resolve(null))
          .then(function (neu) {
            /* Ging die Aenderung nicht durch, bleibt alles stehen — ein
               Neuladen liefe sonst im Kreis. Auf /cart steht die Liste im
               Seitenkoerper, nicht im Schubfach: dort hilft nur neu laden. */
            if (!neu) return;
            if (window.location.pathname === ((window.routes && window.routes.cart_url) || '/cart')) {
              window.location.reload();
            } else {
              neuZeichnen(neu);
            }
          });
      })
      .catch(function () {});
  }

  /* ?warenkorb=auf oeffnet das Schubfach gleich nach dem Laden. Das Quiz
     legt den Duft in den Korb und fuehrt dann auf dessen Seite (Otton
     21.10.2026: "in den warenkorb soll den drawer zeigen auf der jeweiligen
     duftseite", die Seite /cart ist nicht dafuer gebaut). Der Parameter
     verschwindet aus der Adresse, damit Neuladen das Schubfach nicht
     wieder aufreisst. */
  try {
    var adresse = new URL(window.location.href);
    if (adresse.searchParams.get('warenkorb') === 'auf') {
      adresse.searchParams.delete('warenkorb');
      history.replaceState(history.state, '', adresse.pathname + adresse.search + adresse.hash);
      customElements.whenDefined('cart-drawer').then(function () {
        var k = korb();
        if (k && typeof k.open === 'function') setTimeout(function () { k.open(); }, 400);
      });
    }
  } catch (e) {}

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, gratisDeckeln);
  }
  /* Beim Laden nur, wenn das Schubfach beim Rendern zu viele gezaehlt hat
     — sonst kostete jede Seite eine Abfrage mehr. */
  if (document.querySelector('cart-drawer[data-ml-gratis-zuviel]')) gratisDeckeln();

  document.addEventListener('click', function (e) {
    var tester = e.target.closest('[data-ml-korb-tester]');
    if (tester && !tester.disabled) {
      e.preventDefault();
      var tid = Number(tester.getAttribute('data-ml-korb-tester'));
      if (tid) {
        /* Zwei Marken: die mit Unterstrich steuert die Anzeige im
           Schubfach, die ohne steht in der Bestellung. Shopify blendet
           Eigenschaften mit fuehrendem Unterstrich ueberall aus — genau
           deshalb war im Backoffice nie zu sehen, dass eine Probe
           dabeigelegt werden sollte. */
        var eig = { _gratis_tester: 'ja', 'Gratis-Probe': 'ja' };

        /* Eine Probe pro Bestellung, und die Wahl bleibt offen: ein Klick
           auf eine andere Zeile nimmt erst die alte heraus und legt dann
           die neue hinein. Der Haken wandert also, statt dass sich Proben
           sammeln oder die Liste sich sperrt. */
        var liste = tester.closest('[data-ml-tester-alt]');
        var alt = liste ? liste.getAttribute('data-ml-tester-alt') : '';

        if (alt) {
          tester.disabled = true;
          heraus(alt).then(function () {
            tester.disabled = false;
            hinein(tester, tid, eig);
          });
        } else {
          hinein(tester, tid, eig);
        }
      }
      return;
    }

    var kit = e.target.closest('[data-ml-korb-kit]');
    if (kit && !kit.disabled) {
      e.preventDefault();
      var kid = Number(kit.getAttribute('data-ml-korb-kit'));
      if (kid) hinein(kit, kid, null);
    }
  });
})();
